import { TITULOS_FIELDS_FORM } from './../../../constants/titulos.constants';
import { Component, Input, signal, inject, ViewChild } from '@angular/core';
import { CrudCreateComponent } from '../../../shared/components/crud/create/create.component';
import { TituloInterface } from '../../../models/titulo.model';
import { CaracterService } from '../../../core/caracter.service';
import { TituloService } from '../../../core/titulo.service';
import { NivelService } from '../../../core/nivel.service';
import { defaultPaginateSelects } from '../../../utils/paginate.utils';
import { Form } from '../../../shared/components/form/form.component';
@Component({
  selector: 'app-titulos-create',
  templateUrl: './create.html',
  styleUrl: './create.scss',
  imports: [CrudCreateComponent],
})
export class TitulosCreateComponent {
  fields = TITULOS_FIELDS_FORM
  tituloService = inject(TituloService);
  @Input() title: string = '';
  id = signal('');
  caracterService = inject(CaracterService);
  nivelService = inject(NivelService);
  titulo !: TituloInterface
  @ViewChild('createTitulo') createComponente!: CrudCreateComponent<TituloInterface>;
  private subscriptions: any[] = [];
  ngOnInit() {
    //Cargo por defecto los caracteres del nivel 2 (secundario) para que se muestren al crear un titulo nuevo
    const subCaracter = this.caracterService.getAllForSelect({
          ...defaultPaginateSelects,
          mainFilterField: 'nivel_id',
          mainValueToFilter: 2
        }).subscribe((data) => {
          this.fields['caracter_id'].options = [...data];
          if(this.createComponente){
            this.createComponente.setFieldOptions('caracter_id', data);
          }
        });
        this.subscriptions.push(subCaracter);
    const subNivel = this.nivelService.getAllForSelect().subscribe((data) => {
      this.fields['nivel_id'].options = data;
    });
    this.subscriptions.push(subNivel);
  }
  reloadCaracterByNivel(option: { field: string, value: number }) {
    if (this.createComponente && option.field === 'nivel_id') {
      this.createComponente.clearField('caracter_id')
      this.fields['caracter_id'].options = [];
      const subCaracter = this.caracterService.getAllForSelect({
        ...defaultPaginateSelects,
        mainFilterField: 'nivel_id',
        mainValueToFilter: option.value
      }).subscribe((data) => {
        this.fields['caracter_id'].options = [...data];
        this.createComponente.setFieldOptions('caracter_id', data);
      });
      this.subscriptions.push(subCaracter);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}



